import React from "react";

import { MediaPanel } from "../../components/media/index.js";

export default () => <MediaPanel />;
